module.exports = __webpack_public_path__ + "img/up_host.1c5592eb.svg";